export default "__VITE_ASSET__CvvRUyKf__"